import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';

export const Recaptcha = () => {
  const theKey = process.env.GATSBY_PUBLIC_RECAPTCHA_KEY;
  if (!theKey) {
    return null;
  }

  return (
    <Script
      strategy={ScriptStrategy.postHydrate}
      src={`https://www.google.com/recaptcha/enterprise.js?render=${theKey}`}
    />
  );
};
